module.exports = __webpack_public_path__ + "static/media/bmo.4102e19d.png";